// ============================================================
// ComparativeData — replaces app-comparative-data Angular component
// Vertical icon dock on left, content area on right
// Replaces p-dock with a custom vertical nav list
// ============================================================
import React, { useState } from 'react';
import TotalEnrolmentOverTime from './total-enrollment-over-time/TotalEnrollmentOverTime';
import ClasswiseEnrollmentOvertime from './classwise-enrollment-overtime/ClasswiseEnrollmentOvertime';
import TransitionRate from './transition-rate/TransitionRate';
import TotalEnrollmentGender from './total-enrollment-gender/TotalEnrollmentGender';
import enrollmentOverTimeIcon from '../../../assets/images/enrollment/enrollment_over_time.svg';
import enrollmentIcon from '../../../assets/images/enrollment/Enrollment.svg';
import transitionRateIcon from '../../../assets/images/enrollment/transition_rate.svg';
import enrollmentGenderIcon from '../../../assets/images/enrollment/total_enrollment_by_gender.svg';
import '../dashboard.scss';
type TabKey =
  | 'totalEnrollment'
  | 'classwiseEnrollment'
  | 'transitionRate'
  | 'enrollmentGender';

interface DockItem {
  key: TabKey;
  label: string;
  icon: string;
}

const dockItems: DockItem[] = [
  {
    key: 'totalEnrollment',
    label: 'Total Enrollment Over Time',
    icon: enrollmentOverTimeIcon,
  },
  {
    key: 'classwiseEnrollment',
    label: 'ClassWise Enrollment Over Time',
    icon: enrollmentIcon,
  },
  {
    key: 'transitionRate',
    label: 'Transition Rate',
    icon: transitionRateIcon,
  },
  {
    key: 'enrollmentGender',
    label: 'Total Enrollment By Gender',
    icon: enrollmentGenderIcon,
  },
];

const ComparativeData: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabKey>('totalEnrollment');

  return (
    <div>
      {/* Heading */}
      <div className="d-flex center-line align-items-baseline justify-content-center text-center my-4">
        {/* <h5 className="text-uppercase">
          
        </h5> */}
        <button
          className="btn button-color col-sm-3 col-lg-6 col-xl-5 mx-2 headingButton text-uppercase"
          type="button"
        >
          {dockItems.find((d) => d.key === activeTab)?.label ?? ''}
        </button>
      </div>

      <div className="row">
        {/* Left vertical icon nav (replaces p-dock) */}
        <div className="col-md-1">
          <h6 className="p-2 fw-bold">ITEMS</h6>
          <div className="d-flex flex-column gap-3 p-2">
            {dockItems.map((item) => (
              <div
                key={item.key}
                title={item.label}
                onClick={() => setActiveTab(item.key)}
                style={{
                  cursor: 'pointer',
                  opacity: activeTab === item.key ? 1 : 0.5,
                }}
              >
                <img
                  src={item.icon}
                  alt={item.label}
                  width={48}
                  style={{
                    border:
                      activeTab === item.key
                        ? '2px solid #0b7db1'
                        : '2px solid transparent',
                    borderRadius: 8,
                    padding: 4,
                    background:
                      activeTab === item.key ? '#e8f4fc' : 'transparent',
                  }}
                  className={activeTab === item.key ? '' : 'enrollment-items'}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Right content area */}
        <div className="col-md-11">
          {activeTab === 'totalEnrollment' && <TotalEnrolmentOverTime />}
          {activeTab === 'classwiseEnrollment' && (
            <ClasswiseEnrollmentOvertime />
          )}
          {activeTab === 'transitionRate' && <TransitionRate />}
          {activeTab === 'enrollmentGender' && <TotalEnrollmentGender />}
        </div>
      </div>
    </div>
  );
};

export default ComparativeData;
